if (!customElements.get('collection-description-toggle')) {
  customElements.define(
    'collection-description-toggle',
    class CollectionDescriptionToggle extends HTMLElement {
      constructor() {
        super();

        this.button = this.querySelector('[data-description-toggle]');
        this.preview = this.querySelector('[data-description-preview]');
        this.full = this.querySelector('[data-description-full]');
        this.buttonText = this.button?.querySelector('.button-text');
        this.showText = this.dataset.showText || 'Devamini oku';
        this.hideText = this.dataset.hideText || 'Daha az goster';
      }

      connectedCallback() {
        if (!this.button || !this.preview || !this.full || !this.buttonText) return;
        if (this._isBound) return;

        this._isBound = true;
        this.syncVisibility();
        this.button.addEventListener('click', this.handleToggle.bind(this));
      }

      handleToggle() {
        const isExpanded = this.button.getAttribute('aria-expanded') === 'true';
        this.button.setAttribute('aria-expanded', String(!isExpanded));
        this.syncVisibility();
      }

      syncVisibility() {
        const isExpanded = this.button.getAttribute('aria-expanded') === 'true';

        this.preview.hidden = isExpanded;
        this.full.hidden = !isExpanded;
        this.preview.classList.toggle('hidden', isExpanded);
        this.full.classList.toggle('hidden', !isExpanded);
        this.buttonText.textContent = isExpanded ? this.hideText : this.showText;
      }
    }
  );
}
